import { render, staticRenderFns } from "./proposta.vue?vue&type=template&id=623fac7d"
import script from "./proposta.vue?vue&type=script&lang=js"
export * from "./proposta.vue?vue&type=script&lang=js"
import style0 from "./proposta.vue?vue&type=style&index=0&id=623fac7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports